/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tb_GuideInputs */

const en_mk_tb_guide = /** @type {(inputs: Mk_Tb_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See the team setup guide`)
};

const id_mk_tb_guide = /** @type {(inputs: Mk_Tb_GuideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lihat panduan memulai bersama tim`)
};

/**
* | output |
* | --- |
* | "See the team setup guide" |
*
* @param {Mk_Tb_GuideInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tb_guide = /** @type {((inputs?: Mk_Tb_GuideInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tb_GuideInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tb_guide(inputs)
	return en_mk_tb_guide(inputs)
});